import SectionHeader from "components/SectionHeader";
import { Collection } from "./models";
import { collectionDueDate, currencyLabelWhole } from "helpers";

interface CollectionsProps {
    collections: Collection[];
    collectionTotal: number;
}

export default function Collections({ collections, collectionTotal }: CollectionsProps) {
    const hasCollections = collections && collections.length > 0;

    return (
        <div>
            <SectionHeader>Collections due</SectionHeader>
            {hasCollections ? (
                <div className="space-y-2 text-sm">
                    {collections.map((collection) => (
                        <div
                            key={collection.id}
                            className="flex items-start justify-between gap-3 border-b border-gray-100 pb-2"
                        >
                            <div className="min-w-0 flex-1 text-left">
                                <span className="break-words">{collection.reason}</span>
                                <span className="text-gray-500"> ({collectionDueDate(collection.dueOn)})</span>
                            </div>
                            <div className="shrink-0 font-medium">{currencyLabelWhole(collection.amountRemaining)}</div>
                        </div>
                    ))}
                    <div className="flex items-center justify-between pt-1 font-bold">
                        <span>TOTAL</span>
                        <span>{currencyLabelWhole(collectionTotal)}</span>
                    </div>
                </div>
            ) : (
                <div className="my-4 text-gray-500 font-bold text-sm">No collections due</div>
            )}
        </div>
    );
}
